<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <main>
        <section class="pb-15">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div class="border-t pt-14 border-gray-3">
              <h2 class="font-semibold text-heading-5 text-dark">Pejabat</h2>
              <div
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-11 gap-x-7.5"
              >
                <!-- Author Item -->
                <a
                  v-for="(author, index) in formasi.data"
                  :key="author.id || index"
                  href="#"
                  class="group"
                >
                  <div
                    class="border border-gray-3 rounded-[20px] bg-gray p-5 group-hover:bg-white group-hover:drop-shadow-1 group-hover:-translate-y-2 transition-all"
                  >
                    <div class="flex flex-wrap items-center gap-8">
                      <div class="overflow-hidden rounded-full w-25 h-25">
                        <img
                          :src="author.avatar || './images/user/user-01.png'"
                          alt="user"
                        />
                      </div>

                      <div>
                        <h3 class="mb-1 font-semibold text-custom-xl text-dark">
                          {{ author.dosen.nama }}
                        </h3>
                        <p>{{ author.jabatan.namajabatan }}</p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>
<script setup>
import { defineProps } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";

defineProps({
  formasi: {
    type: Object,
    required: true,
  },
});
</script>
